/**
 * Generated from com.dataiku.dip.pivot.frontend.model.DisplayAxis
 */
export enum DisplayAxis {
    axis1 = 'axis1',
    axis2 = 'axis2'
}